module.exports = __webpack_public_path__ + "08068d4d700b382ba55f42a173ed2286.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/sites/hike/logo.svg
// module id = 241
// module chunks = 1